import { env } from '~/shared/config'

/**
 * Default HTTP timeout in milliseconds
 */
export const DEFAULT_HTTP_TIMEOUT = 10_000 // 10 seconds

/**
 * HTTP timeout in milliseconds
 */
export const HTTP_TIMEOUT = Number.isFinite(env.TRIA_CLIENT_HTTP_TIMEOUT)
  ? env.TRIA_CLIENT_HTTP_TIMEOUT
  : DEFAULT_HTTP_TIMEOUT

/**
 * Expected HTTP latency in milliseconds
 * This value is used in Request Policy to determine if request should be postponed,
 * because there is a short limit left in the current bucket, and request might still
 * be successful if it is sent after the limit expires,
 * or if request should be rejected right away
 *
 * TODO: maybe this value should be calculated dynamically based on the network conditions
 */
export const HTTP_LATENCY = 500 // 0.5 seconds
